/* =====================================================================================================================
   batida-v7-piatek.js: "Piątek w biurze" (sections/batida-v7-piatek.liquid; prototype #sub, functions sub() and bd()).
   - Configurator: one choice per row (Jak często / Który dzień / Co przywieźć / Jaki tort / rozmiar), − / + for the
     team size, the live summary. A "Tort urodzinowy" choice (block with data-bd) hides the regular rows and shows the
     birthday list upload, the cake + size and the preview "Tak to zaplanujemy (przykład)".
   - The birthday list (Excel / CSV) goes to Cloudinary (same cloud + unsigned preset as the cake creator; /auto/upload
     so a non-image file is accepted); the link goes into the e-mail.
   - F25 (29.09): the list is read in the browser first (CSV natively, UTF-8 or Windows-1250; XLSX/XLS with SheetJS from
     cdnjs, loaded only when such a file is chosen). "Tak to zaplanujemy" then shows the real names and dates - the 5
     nearest birthdays, weekend birthdays with the working day before - instead of the example; the example stays only
     until a list is read. A file with no readable name + date pairs is refused with a clear message (nothing uploaded).
     The names and dates read also go into the e-mail (under the file link).
   - "Zapytaj o subskrypcję": first click shows the company fields (+ optional "Uwagi", into the e-mail body, and the line
     "... trafi prosto na sklep@batida.pl" under the button), then validates and sends. Sending = the cake
     creator's way (assets/batida-v7-kreator.js): fill the hidden Shopify contact form #v7pw-send (the only form given to
     Shopify.captcha.protect(); the visible fields are not a form) and requestSubmit() it. Shopify comes back with
     ?contact_posted=true -> thank you (only if this form was the one sent: sessionStorage flag).
   - NIP -> Ministerstwo Finansów "Biała Lista" (CORS-open, no key), as in the creator and the cart.
   - 29.09 (Aleksandra): every price with grosze ("165,00 zł", zl()); a missing company or e-mail gives one message
     (T.errCo); the thank-you text gets the customer's e-mail ({email} in T.ok), kept in sessionStorage over the reload.
   - 4.10 (Aleksandra): "Które dni?" takes several days (Mon-Sat, at least one); the summary says "we wtorek i piątek"
     (forms per language: batida.v7.piatek_wd_first / _wd_next / _and). "Inaczej - wybierz daty" (data-v7pw-dates) swaps
     the days for a month calendar: several dates, no Sundays, nothing before today in Europe/Warsaw, up to 12 months
     ahead; arrow keys / Home / End / PageUp / PageDown move, Enter / Space picks. The chosen dates are listed with ×.
     The summary then reads "w wybrane dni: 12.10, 19.10" ({dzien} and its comma drop out of T.sumRegular), "Od kiedy
     startujemy?" is hidden (the first date is the start). Days / dates go into the e-mail in Polish (Konfiguracja + body).
   ===================================================================================================================== */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-v7pw]');
    if (!root || root.hasAttribute('data-v7pw-ready')) return;
    root.setAttribute('data-v7pw-ready', '1');
    var C = {};
    try { C = JSON.parse(root.querySelector('[data-v7pw-cfg]').textContent); } catch (e) { return; }
    var T = C.t || {}, LOC = C.locale || 'pl';
    var MIN = +C.min || 5, MAX = +C.max || 300, STEP = +C.step || 5;

    function $(sel) { return root.querySelector(sel); }
    function $all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function isoDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    // a price always with grosze, as Shopify prints it: "165" / "165,00" / "165.5" / "1.320,00" -> "165,00 zł", "1.320,00 zł"
    function zl(p) {
      var t = String(p == null ? '' : p).replace(/\s|z[łl]/gi, '');
      if (!t) return '';
      if (t.indexOf(',') >= 0 && t.indexOf('.') >= 0) t = t.lastIndexOf(',') > t.lastIndexOf('.') ? t.replace(/\./g, '').replace(',', '.') : t.replace(/,/g, '');
      else if (t.indexOf(',') >= 0) t = t.replace(',', '.');
      else if (/^\d{1,3}(\.\d{3})+$/.test(t)) t = t.replace(/\./g, '');
      var x = parseFloat(t);
      if (!isFinite(x)) return String(p);
      var f = x.toFixed(2).split('.');
      return f[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + f[1] + ' zł';
    }

    var sumEl = $('[data-v7pw-sum]'), bdBox = $('[data-v7pw-bd]'), prev = $('[data-v7pw-prev]'), nEl = $('[data-v7pw-n]');
    var formBox = $('[data-v7pw-form]'), goBtn = $('[data-v7pw-go]'), errBox = $('[data-v7pw-err]');
    var cfgBox = $('[data-v7pw-cfgbox]'), goBox = $('[data-v7pw-gobox]'), done = $('[data-v7pw-done]'), toShop = $('[data-v7pw-to]');
    var n = Math.max(MIN, Math.min(MAX, parseInt(nEl.textContent, 10) || 20));
    var list = { url: '', name: '' }, uploading = false, sending = false, formOpen = false;
    var people = null;                     // F25: [{name, d, m}] read from the uploaded list (null = none yet: example)

    /* every row: exactly one choice (the first one if none is set in the editor); 4.10: the days row takes several */
    $all('[data-v7pw-g]').forEach(function (g) {
      if (g.getAttribute('data-v7pw-g') === 'd') return;
      var on = g.querySelector('.v7pw-o.is-on') || g.querySelector('.v7pw-o');
      pick(g, on);
    });
    function pick(g, o) {
      if (!o) return;
      g.querySelectorAll('.v7pw-o').forEach(function (x) { var y = x === o; x.classList.toggle('is-on', y); x.setAttribute('aria-pressed', y ? 'true' : 'false'); });
    }
    function sel(k) { return root.querySelector('[data-v7pw-g="' + k + '"] .v7pw-o.is-on'); }
    function val(k) { var o = sel(k); return o ? o.getAttribute('data-v7pw-v') : ''; }
    function isBd() { var o = sel('z'); return !!(o && o.hasAttribute('data-bd')); }
    function sizeIndex() {
      var o = sel('bs'); if (!o) return 0;
      return Array.prototype.indexOf.call(o.parentNode.querySelectorAll('.v7pw-o'), o);
    }
    function cakePrice() {
      var o = sel('bt'); if (!o) return '';
      var p = String(o.getAttribute('data-prices') || '').split('|')[sizeIndex()];
      return p ? p.trim() : '';
    }
    function sizeShort() { return val('bs').split(' ·')[0]; }
    function fill(tpl, map) {
      return esc(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
    }

    /* ---------- 4.10 (Aleksandra): several days (Mon-Sat) or "Inaczej - wybierz daty" (calendar) ---------- */
    function list6(s, dflt) { var a = String(s || '').split('|'); return a.length >= 6 ? a : dflt.split('|'); }
    var WD_FIRST = list6(T.wdFirst, 'w poniedziałek|we wtorek|w środę|w czwartek|w piątek|w sobotę');   // index 0 = Monday
    var WD_NEXT = list6(T.wdNext, 'poniedziałek|wtorek|środę|czwartek|piątek|sobotę');
    var DOW_PL = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];       // the e-mail keeps Polish
    function isDates() { var o = sel('f'); return !!(o && o.hasAttribute('data-v7pw-dates')); }
    function dayIdx() {
      return $all('[data-v7pw-g="d"] .v7pw-o.is-on').map(function (o) { return +o.getAttribute('data-i'); })
        .filter(function (i) { return i >= 0 && i <= 5; }).sort(function (a, b) { return a - b; });
    }
    // "w piątek", "we wtorek i piątek", "w poniedziałek, środę i piątek" (the first day carries the preposition)
    function daysPhrase(ix) {
      if (!ix.length) return T.daysNone || '';
      var p = ix.map(function (i, k) { return k ? WD_NEXT[i] : WD_FIRST[i]; });
      return p.length === 1 ? p[0] : p.slice(0, -1).join(', ') + ' ' + (T.and || 'i') + ' ' + p[p.length - 1];
    }
    // dates as 'YYYY-MM-DD', counted in UTC so the visitor's time zone never shifts a day
    function utc(iso) { return Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10)); }
    function isoUTC(ms) { var d = new Date(ms); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
    function addDays(iso, k) { return isoUTC(utc(iso) + k * 864e5); }
    function addMonths(iso, k) {   // 'YYYY-MM' or 'YYYY-MM-DD' (the day is kept, or the month's last one)
      var y = +iso.slice(0, 4), m = +iso.slice(5, 7) - 1 + k, ym = isoUTC(Date.UTC(y, m, 1)).slice(0, 7);
      if (iso.length < 10) return ym;
      var last = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
      return ym + '-' + pad(Math.min(+iso.slice(8, 10), last));
    }
    function wday(iso) { return new Date(utc(iso)).getUTCDay(); }
    function warsawToday() {
      try {
        var p = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' })
          .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        if (p.year && p.month && p.day) return p.year + '-' + p.month + '-' + p.day;
      } catch (e) { /* old browser: the device's date */ }
      return isoDate(new Date());
    }
    var TODAY = warsawToday(), LAST_M = addMonths(TODAY.slice(0, 7), 12), DATES_MAX = 60;
    var picked = [], view = TODAY.slice(0, 7), calFocus = null;
    function dfmt(opts) {
      opts.timeZone = 'UTC';
      try { return new Intl.DateTimeFormat(LOC, opts); } catch (e) { try { return new Intl.DateTimeFormat('pl', opts); } catch (e2) { return null; } }
    }
    var F_MONTH = dfmt({ month: 'long', year: 'numeric' }), F_LONG = dfmt({ weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    var F_WD = dfmt({ weekday: 'short' }), F_WDL = dfmt({ weekday: 'long' });
    function df(f, iso, alt) { try { return f ? f.format(new Date(utc(iso))) : alt; } catch (e) { return alt; } }
    function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
    function dShort(iso) { return +iso.slice(8, 10) + '.' + iso.slice(5, 7) + (iso.slice(0, 4) !== TODAY.slice(0, 4) ? '.' + iso.slice(0, 4) : ''); }
    // the same notice as "Od kiedy startujemy?" (section setting start_min_days, default 2): no dates sooner than that
    var FIRST = addDays(TODAY, +C.startDays || 0);
    function isOff(iso) { return iso < FIRST || wday(iso) === 0 || iso.slice(0, 7) > LAST_M; }

    var dpBox = $('[data-v7pw-dp]'), calEl = $('[data-v7pw-cal]'), chosenBox = $('[data-v7pw-chosenbox]'), chosenEl = $('[data-v7pw-chosen]');
    var startBox = $('[data-v7pw-startbox]');
    if (calEl) {
      calEl.innerHTML = '<div class="v7pw-dp__top">' +
        '<button type="button" class="v7pw-dp__nav" data-v7pw-cm="-1" aria-label="' + esc(T.calPrev || '') + '">‹</button>' +
        '<b class="v7pw-dp__m" data-v7pw-cmon aria-live="polite"></b>' +
        '<button type="button" class="v7pw-dp__nav" data-v7pw-cm="1" aria-label="' + esc(T.calNext || '') + '">›</button></div>' +
        '<table class="v7pw-dp__t"><thead><tr>' + [1, 2, 3, 4, 5, 6, 0].map(function (w) {
          var iso = addDays('2024-01-07', w);   // 7.01.2024 was a Sunday
          return '<th scope="col" abbr="' + esc(df(F_WDL, iso, DOW_PL[w])) + '">' + esc(df(F_WD, iso, DOW_PL[w].slice(0, 3))) + '</th>';
        }).join('') + '</tr></thead><tbody data-v7pw-cbody></tbody></table>';
    }
    // the month on show; one day button is in the Tab order (roving tabindex), focus = move the keyboard focus to it
    function calRender(focus) {
      if (!calEl) return;
      var first = view + '-01', lead = (wday(first) + 6) % 7, days = new Date(utc(addMonths(first, 1)) - 864e5).getUTCDate();
      var tab = calFocus && calFocus.slice(0, 7) === view ? calFocus : null;
      if (!tab) {
        for (var i = 1; i <= days && !tab; i++) { var c = view + '-' + pad(i); if (picked.indexOf(c) >= 0) tab = c; }
        for (var j = 1; j <= days && !tab; j++) { var c2 = view + '-' + pad(j); if (!isOff(c2)) tab = c2; }
        if (!tab) tab = first;
      }
      var cells = [], k;
      for (k = 0; k < lead; k++) cells.push('<td></td>');
      for (k = 1; k <= days; k++) {
        var iso = view + '-' + pad(k), on = picked.indexOf(iso) >= 0, off = isOff(iso);
        cells.push('<td><button type="button" class="v7pw-dp__d' + (on ? ' is-on' : '') + (off ? ' is-off' : '') + '" data-v7pw-day="' + iso + '"' +
          ' tabindex="' + (iso === tab ? '0' : '-1') + '" aria-pressed="' + on + '"' + (off ? ' aria-disabled="true"' : '') +
          (iso === TODAY ? ' aria-current="date"' : '') + ' aria-label="' + esc(df(F_LONG, iso, dShort(iso))) + '">' + k + '</button></td>');
      }
      while (cells.length % 7) cells.push('<td></td>');
      var rows = [];
      for (k = 0; k < cells.length; k += 7) rows.push('<tr>' + cells.slice(k, k + 7).join('') + '</tr>');
      calEl.querySelector('[data-v7pw-cbody]').innerHTML = rows.join('');
      calEl.querySelector('[data-v7pw-cmon]').textContent = cap(df(F_MONTH, first, view));
      var prevB = calEl.querySelector('[data-v7pw-cm="-1"]'), nextB = calEl.querySelector('[data-v7pw-cm="1"]');
      prevB.setAttribute('aria-disabled', view <= TODAY.slice(0, 7) ? 'true' : 'false');
      nextB.setAttribute('aria-disabled', view >= LAST_M ? 'true' : 'false');
      if (focus) { var b = calEl.querySelector('[data-v7pw-day="' + tab + '"]'); if (b) b.focus(); }
    }
    function chosenRender() {
      if (!chosenEl) return;
      if (chosenBox) chosenBox.hidden = !picked.length;
      chosenEl.innerHTML = picked.map(function (iso) {
        return '<li class="v7pw-dp__chip"><span>' + esc(df(F_WD, iso, '') + ' ' + dShort(iso)) + '</span>' +
          '<button type="button" class="v7pw-dp__x" data-v7pw-rm="' + iso + '" aria-label="' + fill(T.dateRemove || '{data}', { data: esc(df(F_LONG, iso, dShort(iso))) }) + '">×</button></li>';
      }).join('');
    }
    function toggleDate(iso) {
      var i = picked.indexOf(iso);
      if (i >= 0) picked.splice(i, 1);
      else if (!isOff(iso) && picked.length < DATES_MAX) { picked.push(iso); picked.sort(); }
      chosenRender(); summary(); showErr('');
    }
    if (calEl) {
      calEl.addEventListener('click', function (e) {
        var nav = e.target.closest('[data-v7pw-cm]');
        if (nav) {
          if (nav.getAttribute('aria-disabled') === 'true') return;
          view = addMonths(view, +nav.getAttribute('data-v7pw-cm')); calFocus = null; calRender(false);
          return;
        }
        var b = e.target.closest('[data-v7pw-day]');
        if (!b || b.getAttribute('aria-disabled') === 'true') return;
        calFocus = b.getAttribute('data-v7pw-day');
        toggleDate(calFocus);
        calRender(calEl.contains(document.activeElement));
      });
      calEl.addEventListener('keydown', function (e) {
        var b = e.target.closest('[data-v7pw-day]');
        if (!b) return;
        var iso = b.getAttribute('data-v7pw-day'), w = (wday(iso) + 6) % 7, to = null;
        switch (e.key) {
          case 'ArrowLeft': to = addDays(iso, -1); break;
          case 'ArrowRight': to = addDays(iso, 1); break;
          case 'ArrowUp': to = addDays(iso, -7); break;
          case 'ArrowDown': to = addDays(iso, 7); break;
          case 'Home': to = addDays(iso, -w); break;
          case 'End': to = addDays(iso, 6 - w); break;
          case 'PageUp': to = addMonths(iso, -1); break;
          case 'PageDown': to = addMonths(iso, 1); break;
        }
        if (!to) return;
        e.preventDefault();
        if (to.slice(0, 7) < TODAY.slice(0, 7)) to = TODAY;
        if (to.slice(0, 7) > LAST_M) return;
        calFocus = to; view = to.slice(0, 7); calRender(true);
      });
    }
    if (chosenEl) {
      chosenEl.addEventListener('click', function (e) {
        var x = e.target.closest('[data-v7pw-rm]');
        if (!x) return;
        var i = picked.indexOf(x.getAttribute('data-v7pw-rm'));
        toggleDate(x.getAttribute('data-v7pw-rm'));
        calRender(false);
        // the focus goes to the next × (or the previous one), or back to the calendar when the list is empty
        var xs = chosenEl.querySelectorAll('[data-v7pw-rm]'), nx = xs[Math.min(i, xs.length - 1)];
        if (nx) nx.focus(); else calRender(true);
      });
    }

    /* the prototype's sub() */
    function summary() {
      var bd = isBd(), dates = !bd && isDates();
      if (bdBox) bdBox.hidden = !bd;
      $all('.v7pw-reg').forEach(function (x) { x.style.display = bd ? 'none' : ''; });
      $all('[data-v7pw-days]').forEach(function (x) { x.hidden = dates; });
      if (dpBox) dpBox.hidden = !dates;
      if (startBox) startBox.hidden = dates;            // 4.10: with chosen dates the first one is the start
      var html;
      if (bd) {
        html = fill(T.sumBd, { zestaw: '<b>' + esc(val('z')) + '</b>', tort: esc(val('bt')), rozmiar: esc(sizeShort()) });
        if (T.sumBd2) html += '<br>' + esc(T.sumBd2);
      } else {
        // 4.10: chosen dates replace "co tydzień, w piątek": {czestotliwosc} = "w wybrane dni: …", {dzien} goes with its comma
        var tpl = T.sumRegular || '';
        if (dates) tpl = tpl.replace(/\s*[,·]\s*\{dzien\}|\{dzien\}\s*[,·]?\s*/, '');
        html = fill(tpl, {
          zestaw: '<b>' + esc(val('z')) + '</b>', osoby: n,
          czestotliwosc: dates ? (picked.length ? fill(T.datesSum || '{daty}', { daty: esc(picked.map(dShort).join(', ')) }) : esc(T.datesNone || ''))
            : esc(val('f').toLowerCase()),
          dzien: esc(daysPhrase(dayIdx()))
        });
        if (T.sumRegular2) html += '<br>' + esc(T.sumRegular2);
      }
      sumEl.innerHTML = html;
      preview();
    }
    function summaryText() { return (sumEl.innerText || sumEl.textContent || '').replace(/\s*\n\s*/g, ' ').trim(); }

    /* the prototype's bd(): the preview - the example until a list is read, then the list's 5 nearest birthdays */
    var DOW = String(T.dow || 'niedziela|poniedziałek|wtorek|środa|czwartek|piątek|sobota').split('|');   // batida.v7.piatek_days
    var PEOPLE = String(T.people || 'osoba|osoby|osób').split('|');                                            // batida.v7.piatek_people (shown; the e-mail keeps Polish)
    function plural(n, one, few, many) { var t = n % 10, h = n % 100; return n === 1 ? one : (t >= 2 && t <= 4 && (h < 12 || h > 14)) ? few : many; }
    function dm(d, m) { return d + '.' + pad(m); }
    // the next birthday from today (29.02 -> 28.02 in other years) and the working day the cake comes (Sat/Sun -> Fri)
    function nextOf(p, today) {
      var y = today.getFullYear(), at = function (yy) { var leap = (yy % 4 === 0 && yy % 100 !== 0) || yy % 400 === 0; return new Date(yy, p.m - 1, p.m === 2 && p.d === 29 && !leap ? 28 : p.d); };
      var n = at(y); if (n < today) n = at(y + 1);
      var w = new Date(n); if (w.getDay() === 6) w.setDate(w.getDate() - 1); else if (w.getDay() === 0) w.setDate(w.getDate() - 2);
      return { date: n, work: w };
    }
    function upcoming(list, max) {
      var t = new Date(); t.setHours(0, 0, 0, 0);
      return list.map(function (p) { var x = nextOf(p, t); return { name: p.name, d: p.d, m: p.m, date: x.date, work: x.work }; })
        .sort(function (a, b) { return a.date - b.date || a.name.localeCompare(b.name, 'pl'); }).slice(0, max);
    }
    function preview() {
      if (!prev) return;
      var price = cakePrice(), cake = val('bt'), size = sizeShort();
      var rows, head = T.bdK, more = '';
      if (people && people.length) {
        rows = upcoming(people, 5).map(function (r) {
          var moved = r.work.getTime() !== r.date.getTime() ? fill(T.bdMoved || 'tort w dzień roboczy wcześniej: {dzien} {data}', { dzien: DOW[r.work.getDay()], data: dm(r.work.getDate(), r.work.getMonth() + 1) }) : '';
          return [r.name, dm(r.d, r.m), moved];
        });
        head = T.bdKList || T.bdK;
        var rest = people.length - rows.length;
        if (rest > 0) more = '<div class="v7pw-prev__n">' + fill(T.bdMore || 'i jeszcze {n} z listy', { n: rest + ' ' + plural(rest, PEOPLE[0], PEOPLE[1], PEOPLE[2]) }) + '</div>';
      } else {
        rows = String(C.example || '').split(',').map(function (x) {
          var m = x.trim().match(/^(.*?)\s+(\S+)$/); return m ? [m[1], m[2], ''] : null;
        }).filter(Boolean);
      }
      prev.classList.toggle('is-list', !!(people && people.length));
      prev.innerHTML = (head ? '<div class="v7pw-prev__k">' + esc(head) + '</div>' : '') + rows.map(function (r) {
        return '<div class="v7pw-prev__r"><b>' + esc(r[1]) + '</b><span>' + esc(r[0]) + '</span><em>' + esc(cake + ' ' + size) + ' · ' +
          fill(T.bdNapis, { imie: esc(r[0]) }) + (r[2] ? ' · ' + r[2] : '') + '</em><i>' + (price ? esc(zl(price)) : '') + '</i></div>';
      }).join('') + more + (T.bdNote ? '<div class="v7pw-prev__n">' + esc(T.bdNote) + '</div>' : '');
    }

    /* ---------- F25: read the birthday list in the browser ---------- */
    var MONTHS = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
    function validDM(d, m) { return m >= 1 && m <= 12 && d >= 1 && d <= [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1]; }
    // a date in a cell: Excel serial (number from a date cell), a Date, "14.10", "14.10.1990", "1990-10-14", "14/10/90",
    // "14 października (1990)". Polish order (day first); "10/14/1990" (US) is read as 14.10 when the day can't be a month.
    function toDM(v) {
      if (v == null || v === '') return null;
      if (v instanceof Date && !isNaN(v)) return { d: v.getDate(), m: v.getMonth() + 1 };
      if (typeof v === 'object' && v.serial != null) {
        var dt = new Date(Date.UTC(1899, 11, 30) + Math.round(v.serial) * 864e5);
        return validDM(dt.getUTCDate(), dt.getUTCMonth() + 1) ? { d: dt.getUTCDate(), m: dt.getUTCMonth() + 1 } : null;
      }
      var s = String(v).trim().toLowerCase().replace(/\s+r\.?$/, ''), x;
      if ((x = s.match(/^(\d{4})[.\/-](\d{1,2})[.\/-](\d{1,2})(?:[ t].*)?$/))) return validDM(+x[3], +x[2]) ? { d: +x[3], m: +x[2] } : null;
      if ((x = s.match(/^(\d{1,2})[.\/-](\d{1,2})(?:[.\/-](\d{2}|\d{4}))?\.?(?:\s.*)?$/))) {
        var a = +x[1], b = +x[2];
        if (validDM(a, b)) return { d: a, m: b };
        if (validDM(b, a)) return { d: b, m: a };
        return null;
      }
      if ((x = s.match(/^(\d{1,2})\.?\s+([a-ząćęłńóśźż]{3,})/))) {
        var mi = -1; MONTHS.forEach(function (p, i) { if (x[2].indexOf(p) === 0 || (i === 9 && x[2].indexOf('paz') === 0)) mi = i; });
        return mi >= 0 && validDM(+x[1], mi + 1) ? { d: +x[1], m: mi + 1 } : null;
      }
      return null;
    }
    function toName(v) {
      if (v == null || typeof v === 'object') return '';
      var s = String(v).replace(/\s+/g, ' ').trim();
      if (!s || s.length > 60 || /^[\d\s.,\/-]+$/.test(s) || /@/.test(s)) return '';
      return s;
    }
    var HEAD_NAME = /imi[eę]|nazwisk|name|osoba|pracown|kto/i, HEAD_DATE = /dat|urodz|birth|dzie[nń]|kiedy/i;
    // rows (arrays of cells) -> {people, skipped}; a header row picks the columns, else every row is searched
    function readList(rows) {
      rows = rows.filter(function (r) { return r && r.some(function (c) { return c != null && String(c).trim() !== ''; }); });
      var nameCol = -1, dateCol = -1, start = 0;
      for (var h = 0; h < Math.min(rows.length, 5); h++) {
        var r = rows[h], nc = -1, dc = -1;
        if (r.some(function (c) { return toDM(c); })) continue;                // a row with a date is data, not a header
        r.forEach(function (c, i) { if (typeof c !== 'string') return; if (nc < 0 && HEAD_NAME.test(c) && !HEAD_DATE.test(c)) nc = i; else if (dc < 0 && HEAD_DATE.test(c)) dc = i; });
        if (nc >= 0 && dc >= 0) { nameCol = nc; dateCol = dc; start = h + 1; break; }
      }
      var out = [], skipped = 0, seen = {};
      rows.slice(start).forEach(function (r) {
        var name = '', dmv = null;
        if (nameCol >= 0) { name = toName(r[nameCol]); dmv = toDM(r[dateCol]); }
        if (!name || !dmv) {
          // no header (or an odd row): the first date anywhere + the first text that isn't one; "Kasia 14.10" in one cell
          name = ''; dmv = null;
          r.forEach(function (c) { if (!dmv) { var t = toDM(c); if (t) { dmv = t; return; } } if (!name) name = toName(c); });
          if (!dmv && r.length === 1 && typeof r[0] === 'string') {
            var one = r[0].match(/^(.*?)[\s,;:–-]+(\d{1,2}[.\/-]\d{1,2}(?:[.\/-]\d{2,4})?\.?)$/);
            if (one) { name = toName(one[1]); dmv = toDM(one[2]); }
          }
        }
        if (name && dmv) {
          var key = name.toLowerCase() + '|' + dmv.d + '.' + dmv.m;
          if (!seen[key]) { seen[key] = 1; out.push({ name: name, d: dmv.d, m: dmv.m }); }
        } else skipped++;
      });
      return { people: out.slice(0, 1000), skipped: skipped };
    }
    function readText(buf) {
      var bytes = new Uint8Array(buf), txt;
      try { txt = new TextDecoder('utf-8', { fatal: true }).decode(bytes); } catch (e) { try { txt = new TextDecoder('windows-1250').decode(bytes); } catch (e2) { txt = new TextDecoder('utf-8').decode(bytes); } }
      return txt.replace(/^\ufeff/, '');
    }
    function csvRows(txt) {
      var first = txt.split(/\r?\n/)[0] || '', delim = [';', '\t', ','].sort(function (a, b) { return first.split(b).length - first.split(a).length; })[0];
      var rows = [], row = [], cell = '', q = false;
      for (var i = 0; i < txt.length; i++) {
        var ch = txt[i];
        if (q) { if (ch === '"') { if (txt[i + 1] === '"') { cell += '"'; i++; } else q = false; } else cell += ch; continue; }
        if (ch === '"') q = true;
        else if (ch === delim) { row.push(cell); cell = ''; }
        else if (ch === '\n' || ch === '\r') { if (ch === '\r' && txt[i + 1] === '\n') i++; row.push(cell); rows.push(row); row = []; cell = ''; }
        else cell += ch;
      }
      if (cell !== '' || row.length) { row.push(cell); rows.push(row); }
      return rows;
    }
    var xlsxReady = null;
    function loadXlsx() {
      if (window.XLSX) return Promise.resolve(window.XLSX);
      if (xlsxReady) return xlsxReady;
      xlsxReady = new Promise(function (res, rej) {
        var sc = document.createElement('script');
        sc.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
        sc.integrity = 'sha512-r22gChDnGvBylk90+2e/ycr3RVrDi8DIOkIGNhJlKfuyQM4tIRAI062MaV8sfjQKYVGjOBaZBOA87z+IhZE9DA==';
        sc.crossOrigin = 'anonymous'; sc.async = true;
        sc.onload = function () { window.XLSX ? res(window.XLSX) : rej(new Error('xlsx')); };
        sc.onerror = function () { xlsxReady = null; rej(new Error('xlsx')); };
        document.head.appendChild(sc);
      });
      return xlsxReady;
    }
    // XLSX/XLS: first sheet with data; date cells become {serial} (Excel's day number, read without time zones)
    function sheetRows(X, buf) {
      var wb = X.read(new Uint8Array(buf), { type: 'array', cellNF: true, cellDates: false, sheetRows: 2000 });
      var date1904 = !!(wb.Workbook && wb.Workbook.WBProps && wb.Workbook.WBProps.date1904);
      for (var si = 0; si < wb.SheetNames.length; si++) {
        var ws = wb.Sheets[wb.SheetNames[si]];
        if (!ws || !ws['!ref']) continue;
        var rg = X.utils.decode_range(ws['!ref']), rows = [];
        for (var r = rg.s.r; r <= Math.min(rg.e.r, rg.s.r + 1999); r++) {
          var row = [];
          for (var c = rg.s.c; c <= Math.min(rg.e.c, rg.s.c + 20); c++) {
            var cell = ws[X.utils.encode_cell({ r: r, c: c })], v = '';
            if (cell) {
              if (cell.t === 'n' && cell.z && X.SSF.is_date(cell.z)) v = { serial: cell.v + (date1904 ? 1462 : 0) };
              else if (cell.t === 'd' && cell.v instanceof Date) v = cell.v;
              else if (cell.t === 'n') v = cell.w != null ? String(cell.w) : String(cell.v);
              else v = cell.v != null ? String(cell.v) : '';
            }
            row.push(v);
          }
          rows.push(row);
        }
        if (rows.some(function (x) { return x.some(function (c) { return c !== ''; }); })) return rows;
      }
      return [];
    }
    function parseFile(file) {
      return file.arrayBuffer().then(function (buf) {
        if (/\.csv$/i.test(file.name)) return csvRows(readText(buf));
        return loadXlsx().then(function (X) { return sheetRows(X, buf); }, function () { throw new Error('xlsx-lib'); });
      }).then(readList);
    }
    function peopleText() {
      if (!people || !people.length) return '';
      return upcoming(people, 1000).map(function (p) { return p.name + ' ' + dm(p.d, p.m); }).join(', ').slice(0, 3000);
    }

    function setN(v) {
      n = Math.max(MIN, Math.min(MAX, v));
      nEl.textContent = n;
      var mi = $('[data-v7pw-d="-1"]'), pl = $('[data-v7pw-d="1"]');
      if (mi) mi.disabled = n <= MIN;
      if (pl) pl.disabled = n >= MAX;
      summary();
    }

    root.addEventListener('click', function (e) {
      var o = e.target.closest('.v7pw-o');
      if (o) {
        if (o.parentNode.getAttribute('data-v7pw-g') === 'd') {   // 4.10: days switch on / off one by one
          var on = !o.classList.contains('is-on');
          o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false');
        } else pick(o.parentNode, o);
        summary(); showErr(''); return;
      }
      var d = e.target.closest('[data-v7pw-d]');
      if (d) { setN(n + STEP * (+d.getAttribute('data-v7pw-d'))); return; }
    });

    /* ---------- birthday list -> Cloudinary ---------- */
    var fileIn = $('[data-v7pw-file]'), drop = $('[data-v7pw-drop]'), dropH = $('[data-v7pw-droph]'), upMsg = $('[data-v7pw-upmsg]');
    var dropText = dropH ? dropH.textContent : '';
    function upNote(msg, bad) { if (!upMsg) return; upMsg.hidden = !msg; upMsg.textContent = msg || ''; upMsg.classList.toggle('is-bad', !!bad); }
    function upload(file) {
      if (!file) return;
      if (!/\.(xlsx|xls|csv)$/i.test(file.name)) { upNote(T.errFileType, true); return; }
      if (file.size > 10 * 1024 * 1024) { upNote(T.errBig, true); return; }
      uploading = true;
      if (drop) { drop.classList.add('is-busy'); drop.classList.remove('is-done'); }
      if (dropH) dropH.textContent = T.uploading || dropText;
      upNote('');
      list = { url: '', name: '' };
      var readOk = false, partial = '';
      // F25: read it here first; a list with no name + date pairs is refused before anything is sent
      parseFile(file)
        .then(function (res) {
          if (!res.people.length) { people = null; preview(); upNote(T.errParse, true); return; }
          readOk = true; people = res.people; preview();
          partial = res.skipped ? fill(T.readPartial || '', { n: res.people.length + ' ' + plural(res.people.length, PEOPLE[0], PEOPLE[1], PEOPLE[2]), pominiete: res.skipped }) : '';
          if (!C.cloud || !C.preset) { upNote(T.errFile, true); return; }
          var fd = new FormData();
          fd.append('file', file);
          fd.append('upload_preset', C.preset);
          return fetch('https://api.cloudinary.com/v1_1/' + C.cloud + '/auto/upload', { method: 'POST', body: fd })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              if (j && j.secure_url) { list = { url: j.secure_url, name: file.name }; if (drop) drop.classList.add('is-done'); upNote(partial); }
              else upNote(T.errFile, true);
            }, function () { upNote(T.errFile, true); });
        }, function (err) {
          people = null; preview();
          upNote(err && err.message === 'xlsx-lib' ? T.errXlsx : T.errParse, true);
        })
        .then(function () {
          uploading = false;
          if (drop) drop.classList.remove('is-busy');
          if (dropH) dropH.textContent = list.url ? '✓ ' + list.name : (readOk ? '✓ ' + file.name : dropText);
          if (fileIn) fileIn.value = '';
        });
    }
    if (fileIn) fileIn.addEventListener('change', function () { upload(fileIn.files && fileIn.files[0]); });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) upload(e.dataTransfer.files[0]); });
    }

    /* ---------- 3.10 (Aleksandra): team birthdays for the regular sets - rows "Imię + dd.mm + ×" or a list ---------- */
    var tbBox = $('[data-v7pw-tb]'), tbRowsEl = $('[data-v7pw-tbrows]'), tbFile = $('[data-v7pw-tbfile]');
    var tbUpH = $('[data-v7pw-tbuph]'), tbMsg = $('[data-v7pw-tbmsg]'), tbUpText = tbUpH ? tbUpH.textContent : '';
    var tbList = { url: '', name: '' }, tbPeople = null, TB_MAX = 50;
    function tbNote(msg, bad) { if (!tbMsg) return; tbMsg.hidden = !msg; tbMsg.textContent = msg || ''; tbMsg.classList.toggle('is-bad', !!bad); }
    function tbRow() {
      var r = document.createElement('div');
      r.className = 'v7pw-tb__row';
      r.innerHTML = '<input class="v7pw-f" type="text" maxlength="40" autocomplete="off" data-tb="n" placeholder="' + esc(T.tbName || 'Imię') + '" aria-label="' + esc(T.tbName || 'Imię') + '">' +
        '<input class="v7pw-f" type="text" maxlength="12" inputmode="decimal" autocomplete="off" data-tb="d" placeholder="' + esc(T.tbDate || 'dd.mm') + '" aria-label="' + esc(T.tbDate || 'dd.mm') + '">' +
        '<button type="button" class="v7pw-tb__x" data-tbx aria-label="' + esc(T.tbRemove || 'Usuń') + '">×</button>';
      tbRowsEl.appendChild(r);
      return r;
    }
    // filled rows -> [{name, d, m}]; a row with only one of the two (or a date that isn't a day) is marked and reported
    function tbRead(mark) {
      var out = [], bad = false;
      if (!tbRowsEl) return { people: out, bad: bad };
      Array.prototype.forEach.call(tbRowsEl.querySelectorAll('.v7pw-tb__row'), function (r) {
        var ni = r.querySelector('[data-tb="n"]'), di = r.querySelector('[data-tb="d"]');
        var name = toName(ni.value), raw = di.value.trim(), dmv = raw ? toDM(raw) : null;
        if (!ni.value.trim() && !raw) return;
        if (name && dmv) { out.push({ name: name, d: dmv.d, m: dmv.m }); return; }
        bad = true;
        if (mark) { if (!name) ni.classList.add('is-bad'); if (!dmv) di.classList.add('is-bad'); }
      });
      return { people: out, bad: bad };
    }
    if (tbBox && tbRowsEl) {
      tbRow();
      tbBox.addEventListener('click', function (e) {
        if (e.target.closest('[data-v7pw-tbadd]')) {
          if (tbRowsEl.children.length < TB_MAX) { var r = tbRow(); r.querySelector('input').focus(); }
          return;
        }
        var x = e.target.closest('[data-tbx]');
        if (x) {
          x.parentNode.remove();
          if (!tbRowsEl.children.length) tbRow();
          if (errBox && !errBox.hidden) showErr('');
        }
      });
      tbBox.addEventListener('input', function (e) {
        if (e.target.classList) e.target.classList.remove('is-bad');
        if (errBox && !errBox.hidden) showErr('');
      });
      // "12.11" also from "1211" / "12 11" when the field is left
      tbBox.addEventListener('blur', function (e) {
        var t = e.target;
        if (!t || t.getAttribute('data-tb') !== 'd') return;
        var raw = t.value.trim(), dmv = toDM(raw.replace(/^(\d{1,2})[\s,]+(\d{1,2})$/, '$1.$2').replace(/^(\d{2})(\d{2})$/, '$1.$2'));
        if (dmv) t.value = pad(dmv.d) + '.' + pad(dmv.m);
      }, true);
    }
    function tbUpload(file) {
      if (!file) return;
      if (!/\.(xlsx|xls|csv)$/i.test(file.name)) { tbNote(T.errFileType, true); return; }
      if (file.size > 10 * 1024 * 1024) { tbNote(T.errBig, true); return; }
      uploading = true;
      if (tbUpH) tbUpH.textContent = T.uploading || tbUpText;
      tbNote('');
      tbList = { url: '', name: '' };
      var readOk = false;
      parseFile(file)
        .then(function (res) {
          if (!res.people.length) { tbPeople = null; tbNote(T.errParse, true); return; }
          readOk = true; tbPeople = res.people;
          var got = res.people.length + ' ' + plural(res.people.length, PEOPLE[0], PEOPLE[1], PEOPLE[2]);
          var partial = res.skipped ? fill(T.readPartial || '', { n: got, pominiete: res.skipped }) : '';
          tbNote(partial);
          if (!C.cloud || !C.preset) return;              // the names + dates still go into the e-mail
          var fd = new FormData();
          fd.append('file', file);
          fd.append('upload_preset', C.preset);
          return fetch('https://api.cloudinary.com/v1_1/' + C.cloud + '/auto/upload', { method: 'POST', body: fd })
            .then(function (r) { return r.json(); })
            .then(function (j) { if (j && j.secure_url) tbList = { url: j.secure_url, name: file.name }; }, function () { /* names + dates are enough */ });
        }, function (err) {
          tbPeople = null;
          tbNote(err && err.message === 'xlsx-lib' ? T.errXlsx : T.errParse, true);
        })
        .then(function () {
          uploading = false;
          if (tbUpH) tbUpH.textContent = readOk ? '✓ ' + file.name + ' · ' + tbPeople.length + ' ' + plural(tbPeople.length, PEOPLE[0], PEOPLE[1], PEOPLE[2]) : tbUpText;
          if (tbFile) tbFile.value = '';
        });
    }
    if (tbFile) tbFile.addEventListener('change', function () { tbUpload(tbFile.files && tbFile.files[0]); });
    function tbText() {
      var rows = tbRead(false).people, fromFile = tbPeople || [];
      if (!rows.length && !fromFile.length && !tbList.url) return '';
      var all = upcoming(rows.concat(fromFile), 1000).map(function (p) { return p.name + ' ' + dm(p.d, p.m); });
      return (all.length ? all.length + ' ' + plural(all.length, 'osoba', 'osoby', 'osób') + ': ' + all.join(', ').slice(0, 3000) : '') +
        (tbList.url ? (all.length ? ' | ' : '') + 'plik: ' + tbList.url + ' (' + tbList.name + ')' : '');
    }

    /* ---------- company fields ---------- */
    var F = {};
    $all('[data-v7pw-in]').forEach(function (el) {
      F[el.getAttribute('data-v7pw-in')] = el;
      el.addEventListener('input', function () { el.classList.remove('is-bad'); if (errBox && !errBox.hidden) showErr(''); });
    });
    if (F.start) {
      var min = new Date(); min.setHours(0, 0, 0, 0); min.setDate(min.getDate() + (+C.startDays || 0));
      F.start.min = isoDate(min);
    }
    function isValidNip(nip) {
      nip = String(nip || '').replace(/[\s\-]/g, '');
      if (!/^\d{10}$/.test(nip)) return false;
      var w = [6, 5, 7, 2, 3, 4, 5, 6, 7], sum = 0;
      for (var i = 0; i < 9; i++) sum += parseInt(nip.charAt(i), 10) * w[i];
      var c = sum % 11;
      return c !== 10 && c === parseInt(nip.charAt(9), 10);
    }
    var nipStatus = $('[data-v7pw-nipstatus]'), mf = null, nipTimer = null, lastNip = '';
    function setNip(kind, text) {
      if (!nipStatus) return;
      nipStatus.hidden = !text;
      nipStatus.className = 'v7pw-nip' + (kind ? ' is-' + kind : '');
      nipStatus.textContent = text || '';
    }
    function nipLookup(nip) {
      setNip('', T.nipLoad);
      fetch('https://wl-api.mf.gov.pl/api/search/nip/' + nip + '?date=' + isoDate(new Date()), { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var s = j && j.result && j.result.subject;
          if (!s) { mf = null; setNip('err', T.nipNotFound); return; }
          var addr = (s.workingAddress || s.residenceAddress || '').replace(/\s+/g, ' ').trim();
          mf = { name: s.name || '', address: addr, vat: s.statusVat || '' };
          if (s.name && F.company && !F.company.value.trim()) { F.company.value = s.name; F.company.classList.remove('is-bad'); }
          /* the registered address goes into the e-mail (invoice); the delivery address stays the shopper's own */
          setNip('ok', (s.name || T.nipOk) + (addr ? ' · ' + addr : ''));
        })
        .catch(function () { mf = null; setNip('err', T.nipErr); });
    }
    if (F.nip) {
      F.nip.addEventListener('input', function () {
        var cleaned = (F.nip.value || '').replace(/\D/g, '').slice(0, 10);
        if (cleaned !== F.nip.value) F.nip.value = cleaned;
        clearTimeout(nipTimer);
        if (!cleaned.length) { setNip('', ''); lastNip = ''; mf = null; return; }
        if (cleaned.length === 10 && cleaned !== lastNip) {
          if (!isValidNip(cleaned)) { setNip('err', T.nipInvalid); lastNip = ''; mf = null; return; }
          nipTimer = setTimeout(function () { lastNip = cleaned; nipLookup(cleaned); }, 350);
        }
      });
    }

    function showErr(msg) { if (!errBox) return; errBox.hidden = !msg; errBox.textContent = msg || ''; }
    function shake(el) { if (!el) return; el.classList.remove('v7pw-shake'); void el.offsetWidth; el.classList.add('v7pw-shake'); }
    function v(k) { return F[k] ? F[k].value.trim() : ''; }
    var badEl = null;                                    // 4.10: where the focus goes for a missing day / date
    function problem() {
      badEl = null;
      $all('.v7pw-f.is-bad').forEach(function (f) { f.classList.remove('is-bad'); });
      function bad(k) { if (F[k]) F[k].classList.add('is-bad'); }
      if (uploading) return T.errUpload;
      if (isBd() && C.listRequired && !list.url && !(people && people.length)) return T.errList;
      if (!isBd() && isDates() && !picked.length) { badEl = calEl && calEl.querySelector('[data-v7pw-day][tabindex="0"]'); return T.errDates; }
      if (!isBd() && !isDates() && !dayIdx().length) { badEl = $('[data-v7pw-g="d"] .v7pw-o'); return T.errDays; }
      if (!isBd() && tbRead(true).bad) return T.errTb || T.errData;
      var noCo = v('company').length < 2, noMail = !v('email');
      if (noCo || noMail) { if (noCo) bad('company'); if (noMail) bad('email'); return T.errCo; }
      var nip = v('nip');
      if ((C.nipRequired || nip) && !isValidNip(nip)) { bad('nip'); return T.errNip; }
      var okName = v('name').length > 2, okMail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v('email')), okTel = v('phone').replace(/\D/g, '').length >= 9;
      if (!okName) bad('name'); if (!okTel) bad('phone'); if (!okMail) bad('email');
      if (!okName || !okMail || !okTel) return T.errData;
      if (v('address').length < 6) { bad('address'); return T.errAddr; }
      var st = v('start');
      if (!(!isBd() && isDates()) && (!st || (F.start.min && st < F.start.min))) { bad('start'); return T.errStart; }
      return '';
    }

    /* ---------- send (the creator's way) ---------- */
    var sendForm = document.getElementById('v7pw-send'), armed = false;
    if (sendForm && window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(sendForm, function () { if (armed) sendForm.submit(); });
    }
    function fld(name) { return sendForm.querySelector('[data-v7pw-fld="' + name + '"]'); }
    function config() {
      if (isBd()) return [val('z') + ': ' + val('bt') + ' ' + val('bs') + (cakePrice() ? ' (' + zl(cakePrice()) + ' z napisem)' : '')];
      // 4.10: the chosen days ("wtorek, piątek") or dates ("12.10.2026 (poniedziałek), …"), always in Polish
      if (isDates()) return [
        'Co przywieźć: ' + val('z'),
        'Jak często: Inaczej - wybrane daty',
        'Wybrane daty (' + picked.length + '): ' + picked.map(function (iso) {
          return iso.slice(8, 10) + '.' + iso.slice(5, 7) + '.' + iso.slice(0, 4) + ' (' + DOW_PL[wday(iso)] + ')';
        }).join(', '),
        'Ile osób w zespole: ' + n
      ];
      return [
        'Co przywieźć: ' + val('z'),
        'Jak często: ' + val('f'),
        'Które dni: ' + dayIdx().map(function (i) { return DOW_PL[i + 1]; }).join(', '),
        'Ile osób w zespole: ' + n
      ];
    }
    function startDate() { return !isBd() && isDates() ? (picked[0] || '') : v('start'); }
    function send() {
      var cfg = config(), sum = summaryText();
      var listLine = list.url ? list.url + ' (' + list.name + ')' : (isBd() ? (people && people.length ? '- (plik nie dotarł, osoby poniżej)' : '- (brak pliku)') : '');
      var read = isBd() ? peopleText() : '';
      var tb = isBd() ? '' : tbText();
      var body = ['ZAPYTANIE: PIĄTEK W BIURZE (subskrypcja dla firm)']
        .concat(cfg)
        .concat(isBd() ? ['Lista urodzin: ' + listLine] : [])
        .concat(read ? ['Osoby z listy (' + people.length + ', od najbliższych urodzin): ' + read] : [])
        .concat(tb ? ['Urodziny w zespole (tort z imieniem w dniu urodzin, od najbliższych): ' + tb] : [])
        .concat([
          'Podsumowanie: ' + sum,
          '---',
          'Firma: ' + v('company'),
          'NIP: ' + (v('nip') || '-') + (mf ? ' | Biała Lista: ' + mf.name + (mf.address ? ', ' + mf.address : '') + (mf.vat ? ' (VAT: ' + mf.vat + ')' : '') : ''),
          'Osoba kontaktowa: ' + v('name'),
          'Telefon: ' + v('phone'),
          'E-mail: ' + v('email'),
          'Adres dostawy: ' + v('address'),
          'Data startu: ' + startDate(),
          'Uwagi: ' + (v('note') || '-'),
          'Język klienta: ' + LOC
        ]).join('\n');
      fld('email').value = v('email');
      fld('name').value = v('name');
      fld('phone').value = v('phone');
      fld('company').value = v('company');
      fld('nip').value = v('nip');
      fld('address').value = v('address');
      fld('start').value = startDate();
      if (fld('note')) fld('note').value = v('note');
      fld('config').value = cfg.join(' | ');
      fld('list').value = isBd() ? listLine + (read ? ' | ' + people.length + ' ' + plural(people.length, 'osoba', 'osoby', 'osób') : '') : (tb ? 'Urodziny w zespole: ' + tb.slice(0, 500) : '');
      fld('body').value = body;
      try { sessionStorage.setItem('v7pw-sent', JSON.stringify({ sum: sumEl.innerHTML, email: v('email') })); } catch (e) { /* private mode */ }
      sending = true;
      goBtn.disabled = true;
      goBtn.textContent = T.sending || goBtn.textContent;
      armed = true;
      if (typeof sendForm.requestSubmit === 'function') sendForm.requestSubmit(); else sendForm.submit();
    }

    goBtn.addEventListener('click', function () {
      if (sending) return;
      if (!formOpen) {
        formOpen = true;
        formBox.hidden = false;
        if (toShop) toShop.hidden = false;
        goBtn.textContent = T.send || goBtn.textContent;
        var first = F.company;
        if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
        formBox.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var msg = problem();
      if (msg) { showErr(msg); shake(goBtn); var b = badEl || root.querySelector('.v7pw-f.is-bad'); if (b) b.focus(); return; }
      showErr('');
      send();
    });

    /* ---------- after Shopify's redirect ---------- */
    // the thank-you text with the e-mail typed before sending; without it (another tab, no sessionStorage) "na {email}" goes
    function okText(mail) {
      var t = T.ok || '';
      if (mail) return t.split('{email}').join(mail);
      return t.replace(/\s*[^\s{]+\s+\{email\}/, '').split('{email}').join('').replace(/\s{2,}/g, ' ');
    }
    var mine = null;
    try { mine = JSON.parse(sessionStorage.getItem('v7pw-sent') || 'null'); } catch (e) { mine = null; }
    /* another enquiry form on the same page (e.g. the catering form) posts to the same /contact: then only the flag counts */
    var onlyForm = !Array.prototype.some.call(document.querySelectorAll('form'), function (f) {
      return f !== sendForm && f.querySelector('[name="contact[body]"]');
    });
    if ((C.posted || /[?&]contact_posted=true/.test(location.search)) && (mine || onlyForm)) {
      try { sessionStorage.removeItem('v7pw-sent'); } catch (e) { /* fine */ }
      summary();
      if (mine && mine.sum) sumEl.innerHTML = mine.sum;
      cfgBox.hidden = true; formBox.hidden = true; goBox.hidden = true; showErr('');
      var okEl = done.querySelector('[data-v7pw-oktext]');
      if (okEl) okEl.textContent = okText(mine && mine.email);
      done.hidden = false;
      setTimeout(function () { root.scrollIntoView({ block: 'start' }); try { done.focus({ preventScroll: true }); } catch (e) { /* */ } }, 60);
      return;
    }

    calRender(false);
    setN(n);
    if (C.failed && mine) { formOpen = true; formBox.hidden = false; if (toShop) toShop.hidden = false; goBtn.textContent = T.send || goBtn.textContent; showErr(T.errSend); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
